import UserDashboard from '@/components/common/UserDashboard';
import Layout from '@/components/Layout/Layout';
import { fetchUserDetails } from '@/redux/features/UserSlice';
import { AppDispatch } from '@/redux/store';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const Dashboard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(fetchUserDetails());
  }, []);
  return (
    <Layout>
      <UserDashboard />
    </Layout>
  );
};
export default Dashboard;
